// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ExternalLinkType;
(function (ExternalLinkType) {
    ExternalLinkType[ExternalLinkType["UNKNOWN"] = -1] = "UNKNOWN";
    ExternalLinkType[ExternalLinkType["NONE"] = 0] = "NONE";
    ExternalLinkType[ExternalLinkType["LINK_TOKEN_LANG"] = 1] = "LINK_TOKEN_LANG";
    ExternalLinkType[ExternalLinkType["TRADING_CENTRAL"] = 2] = "TRADING_CENTRAL";
    ExternalLinkType[ExternalLinkType["AUTOCHARTIST_RP"] = 3] = "AUTOCHARTIST_RP";
    ExternalLinkType[ExternalLinkType["AUTOCHARTIST_IFRAME"] = 4] = "AUTOCHARTIST_IFRAME";
    ExternalLinkType[ExternalLinkType["ITCHART_ADVANCED"] = 5] = "ITCHART_ADVANCED";
    ExternalLinkType[ExternalLinkType["YOUTUBE_LINK"] = 6] = "YOUTUBE_LINK";
    ExternalLinkType[ExternalLinkType["WEB_CONTAINER"] = 7] = "WEB_CONTAINER";
    ExternalLinkType[ExternalLinkType["TOKEN_POST"] = 9] = "TOKEN_POST";
})(ExternalLinkType || (ExternalLinkType = {}));
